// Б.2.a: Экспериментальная батарея — Посмертие носителя.
// 5 раз бьёт по 1 урону по случайным вражеским юнитам, ИГНОРИРУЯ Броню.
//
// Правила (из задания Б.2.a):
//   - Срабатывает в момент смерти носителя независимо от причины (атака,
//     Действие, Перегрузка, Цифровое завещание).
//   - 5 независимых роллов; цели выбираются с заменой (один юнит может
//     получить несколько ударов).
//   - Если на момент очередного удара живых вражеских юнитов нет — удар
//     пропадает (НЕ бьёт по Герою, НЕ по своим).
//   - Игнор Брони — урон проходит мимо неё.
//   - Каждый удар может вызвать смерть и каскад Посмертий (стандартный
//     dispatch).

import { applyDamage } from '../../combat.js';
import { dispatchUnitDied } from '../deus/hooks.js';
// Б.2.c: триггер «союзный персонаж получил урон» (Тёмный нетраннер).
import { notifyCharacterDamaged } from './temnyy-netranner.js';

export const MOD_ID = 'syn_mod_batareya';
const SHOTS = 5;

// state          — состояние матча.
// deadOwnerIdx   — владелец погибшего носителя (атаки идут по его врагам).
// carrier        — погибший Card (для лога).
export function batareyaOnDeath(state, deadOwnerIdx, carrier) {
  state.log.add(`💥 ${carrier.name_ru} [${state.players[deadOwnerIdx].name}]: Эксп. батарея — 5 ударов по 1 (игнор Брони)`);
  // Этап 56.48 (решение фаундера «под текст»): бьёт по случайным юнитам ОБЕИХ
  // сторон (своим И вражеским), а не только по врагам. Каждый удар — заново
  // собираем пул живых юнитов обеих сторон.
  for (let shot = 1; shot <= SHOTS; shot++) {
    const pool = [];
    for (let pIdx = 0; pIdx < state.players.length; pIdx++) {
      for (const u of state.players[pIdx].unitsOnField()) pool.push({ u, pIdx });
    }
    if (pool.length === 0) {
      state.log.add(`💥 Батарея: удар ${shot}/${SHOTS} — нет живых юнитов, пропуск`);
      continue;
    }
    const { u: target, pIdx: tIdx } = pool[state.rng.int(pool.length)];
    const owner = state.players[tIdx];
    const before = { hp: target.hp, armor: target.armor };
    const r = applyDamage(target, 1, { pierce: true });
    state.log.add(
      `💥 Батарея: удар ${shot}/${SHOTS} → ${target.name_ru} [${owner.name}]: ` +
      `1 урона (HP ${before.hp}→${target.hp}, броня ${before.armor}` +
      (r.ignoredArmor > 0 ? ` игнор. ${r.ignoredArmor}` : '') + `)`
    );
    // Б.2.c: триггер урона по персонажу (Тёмный нетраннер) — со стороны владельца цели.
    const taken = (r.armorAbsorbed || 0) + (r.hpLost || 0);
    if (taken > 0) notifyCharacterDamaged(state, tIdx, target, taken);
    if (target.hp <= 0) {
      owner.removeFromField(target);
      state.log.add(`✗ ${target.name_ru} [${owner.name}] погибает`);
      dispatchUnitDied(state, {
        ownerIdx: tIdx, card: target,
        killer: carrier, killerIdx: deadOwnerIdx, killerWasCounter: false
      });
    }
  }
}
